<form>
  <p-select-button
    [options]="languages"
    [allowEmpty]="false"
    [formControl]="formControl"
    (onChange)="onLanguageClick($event.value)"
    data-testid="select-language"
    class="h-10"
  >
  </p-select-button>
</form>
